module.exports = __webpack_public_path__ + "img/img-5.fc68d159.png";